module.exports = __webpack_public_path__ + "static/media/camera-retro.1da555c1.svg";